module.exports = __webpack_public_path__ + "img/Logo_TecNM_Vertical.9d5b03dc.svg";